import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../../../Translations';

interface Props {
  icon: React.ReactNode;
  messageKey: TPlainTextKey;
}

function StatusMessage({ icon, messageKey }: Props) {
  return (
    <div className="flex flex-col items-center">
      {icon}
      <p className="mb-4 mt-8 text-2xl font-semibold">
        <T kind={messageKey} />
      </p>
    </div>
  );
}

export default observer(StatusMessage);
